import PopupContainer from "../popupContainer/popupContainer.vue";
import Vue from 'vue'
import Component from 'vue-class-component'
import moduleStore from '../../store/videoEditor';
import PageState from '../../store/state';

@Component({
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    visible: {
      handler(val) {
        this.show = val
      },
      immediate: true
    }
  },

  components: {
    PopupContainer
  }
})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames
})

//参考style-select-popper
export default class ExportPopup extends Vue{
  state = new PageState();
  show   = false;
  resolutionRatioList=[
    {resolutionRatio:'480P', resolution: 480, text:'普清视频'},
    {resolutionRatio:'720P', resolution: 720, text:'标清视频'},
    {resolutionRatio:'1080P', resolution: 1080, text:'高清视频'},
    // 2k：2560×1440；4k：3840×2160 
    {resolutionRatio:'2K/4K', resolution: 2560, text:'超清视频'}
  ]
  frameRateList =  ['24','25','30','50','60'];
  styleCount = 30;
  frameRateValue=2
  codeRateValue = 1
  activeIdx = 1

  created(moduleData: IinjectDatas) {
    this.state = <PageState>moduleData.state;
  }
  closePopup() {
    this.$emit('close')
  }
  changeEffect(){
    let  codeStrList = ['较低','推荐','较高'];
    let resolutionRatio = this.resolutionRatioList[this.activeIdx].resolutionRatio
    const resolution = this.resolutionRatioList[this.activeIdx].resolution
    this.$emit('exportParams',{resolutionRatio:resolutionRatio,resolution:resolution,frameRateValue:this.frameRateList[this.frameRateValue],codeRateValue:codeStrList[this.codeRateValue]})
  }
}